module.exports = __webpack_public_path__ + "static/media/project_impressos.88d5f95b.jpg";